import { createApi } from '@core/fetch'

/**
 * 四大团队设置
 */
export default {
  getSetting: createApi('/hps/admin/localServerMerchant/fourRole/setting'),
  postSetting: createApi.post(
    '/hps/admin/localServerMerchant/fourRole/setting'
  ),
  quitGroup: createApi.post('/hps/admin/localServerMerchant/fourRole/quitGroup')
}
